import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMyDataQuery } from '@/generated/graphql';
import { useFreecutStudioAccess } from '@/hooks/use-freecut-studio-access';

/** Gates `/clips/:id/freecut` on the freecut_studio plan feature or an admin account (waits for
 *  `myData` first, so a flagged user is never bounced while it loads). */
const FreecutStudioFeatureRoute = ({ children }: { children: ReactNode }) => {
  const { loading } = useMyDataQuery();
  const hasStudio = useFreecutStudioAccess();

  if (loading) return null;

  if (!hasStudio) {
    return <Navigate to="/clips" replace />;
  }

  return <>{children}</>;
};

export default FreecutStudioFeatureRoute;
